import { createClient as createSupabaseClient } from "@supabase/supabase-js";
// Safe environment variable access that works in both Node.js and browser
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getProcessEnv = (key) => {
    try {
        // This will be replaced by bundlers in browser context, or work in Node.js
        return (typeof process !== "undefined" && process?.env?.[key]) || "";
    }
    catch {
        return "";
    }
};
const supabaseUrl = getProcessEnv("SUPABASE_URL") || getProcessEnv("VITE_SUPABASE_URL");
const supabaseAnonKey = getProcessEnv("SUPABASE_ANON_KEY") || getProcessEnv("VITE_SUPABASE_ANON_KEY");
/**
 * Create a Supabase client with custom URL and key
 */
export function createClient(url, anonKey) {
    return createSupabaseClient(url, anonKey);
}
/**
 * Default Supabase client using environment variables
 * Note: This will only work if environment variables are set
 */
export const supabase = supabaseUrl && supabaseAnonKey
    ? createSupabaseClient(supabaseUrl, supabaseAnonKey)
    : null;
//# sourceMappingURL=client.js.map